/* eslint-disable max-len */
import { RecommendationID } from '../constants';

const Strings = {
  HeaderNeverUsedNoDismiss: _TL_('Import from Google Ads'),
  HeaderNeverUsedOneDismiss: _TL_('Connect to your Google Ads account'),
  HeaderResumeImport: _TL_('Resume your Google import'),
  HeaderResumeSchedule: _TL_('Resume your Google import schedule'),
  HeaderSmartNeverUsedNoDismiss: _TL_('Import smart campaigns from Google Ads'),
  HeaderSmartNeverUsedOneDismiss: _TL_('Connect to your Google Ads account'),
  HeaderPinterestNeverUsedNoDismiss: _TL_('Import from Pinterest Ads'),
  HeaderPinterestNeverUsedOneDismiss: _TL_('Connect to your Pinterest Ads account'),
  HeaderFacebookAudienceSupportNoDismiss: _TL_('Import from Meta Ads'),
  HeaderFacebookAudienceSupportOneDismiss: _TL_('Import Audiences from Meta Ads'),
  ContentNeverUsedNoDismiss: _TL_("Microsoft Advertising imports your existing campaigns from Google Ads so you don't have to start from scratch."),
  ContentNeverUsedOneDismiss: _TL_('Connect to your Google Ads account to easily import campaigns, ad groups, and keywords from Google. The more you import from Google Ads, the more data Microsoft Advertising has to give you better recommendations, such as new keywords and better budgets. '),
  ContentResumeImport: _TL_("We noticed you haven't imported from Google ads lately. Resume your imports to make sure your Microsoft Advertising and Google Ads accounts remain synced."),
  ContentResumeSchedule: _TL_('Resume your scheduled imports to make sure your Microsoft Advertising and Google Ads accounts remain synced.'),
  ContentSmartNeverUsedNoDismiss: _TL_("Microsoft Advertising imports your existing smart campaigns from Google Ads so you don't have to start from scratch."),
  ContentSmartNeverUsedOneDismiss: _TL_('Connect to your Google Ads account to easily import smart campaigns. The more you import from Google Ads, the more data Microsoft Advertising has to give you better recommendations. '),
  ContentPinterestNeverUsedNoDismiss: _TL_("Microsoft Advertising imports your existing campaigns from Pinterest Ads so you don't have to start from scratch."),
  ContentPinterestNeverUsedOneDismiss: _TL_('Connect to your Pinterest Ads account to easily import campaigns, ad groups, and keywords from Pinterest. The more you import from Pinterest Ads, the more data Microsoft Advertising has to give you better recommendations, such as new keywords and better budgets. '),
  ContentFacebookAudienceSupportNoDismiss: _TL_("Microsoft Advertising imports your existing campaigns from Meta Ads, so you don't have to start from scratch."),
  ContentFacebookAudienceSupportOneDismiss: _TL_('Import all supported audiences from Meta Ads to ensure a more targeted ad delivery. '),
  ButtonGetStarted: _TL_('Get started'),
  ButtonResumeSchedule: _TL_('Resume import schedule'),
  ButtonNoDismiss: _TL_('Remind me later'),
  ButtonOneDismiss: _TL_('Not now'),
  LearnMoreLink: _TL_('Learn more'),
};

const recommendationVewModels = {
  [RecommendationID.ResumeScheduleId]: ({
    dismissCount, i18n, onGoToScheduleAndHistory, onDismiss,
  }) => ({
    title: i18n.getString(Strings.HeaderResumeSchedule),
    content: i18n.getString(Strings.ContentResumeSchedule),
    buttons: [
      { label: i18n.getString(Strings.ButtonResumeSchedule), onClick: onGoToScheduleAndHistory, isPrimary: true },
      { label: dismissCount === 0 ? i18n.getString(Strings.ButtonNoDismiss) : i18n.getString(Strings.ButtonOneDismiss), onClick: onDismiss },
    ],
  }),

  [RecommendationID.NeverUsedId]: ({
    dismissCount, i18n, onGotoGoogleImport, onDismiss,
  }) => ({
    title: dismissCount === 0 ? i18n.getString(Strings.HeaderNeverUsedNoDismiss) : i18n.getString(Strings.HeaderNeverUsedOneDismiss),
    content: dismissCount === 0 ? i18n.getString(Strings.ContentNeverUsedNoDismiss) : i18n.getString(Strings.ContentNeverUsedOneDismiss),
    contentHelpId: dismissCount > 0 ? 'app51001' : null,
    couponHelpId: 'pop_BA_Import_Google_GetStarted',
    buttons: [
      { label: i18n.getString(Strings.ButtonGetStarted), onClick: onGotoGoogleImport, isPrimary: true },
      { label: dismissCount === 0 ? i18n.getString(Strings.ButtonNoDismiss) : i18n.getString(Strings.ButtonOneDismiss), onClick: onDismiss },
    ],
  }),

  [RecommendationID.ResumeImportId]: ({
    dismissCount, i18n, onGotoGoogleImport, onDismiss,
  }) => ({
    title: i18n.getString(Strings.HeaderResumeImport),
    content: i18n.getString(Strings.ContentResumeImport),
    buttons: [
      { label: i18n.getString(Strings.ButtonGetStarted), onClick: onGotoGoogleImport, isPrimary: true },
      { label: dismissCount === 0 ? i18n.getString(Strings.ButtonNoDismiss) : i18n.getString(Strings.ButtonOneDismiss), onClick: onDismiss },
    ],
  }),

  [RecommendationID.SmartNeverUsedId]: ({
    dismissCount, i18n, onGotoGoogleImport, onDismiss,
  }) => ({
    title: dismissCount === 0 ? i18n.getString(Strings.HeaderSmartNeverUsedNoDismiss) : i18n.getString(Strings.HeaderSmartNeverUsedOneDismiss),
    content: dismissCount === 0 ? i18n.getString(Strings.ContentSmartNeverUsedNoDismiss) : i18n.getString(Strings.ContentSmartNeverUsedOneDismiss),
    contentHelpId: dismissCount > 0 ? 'ext60141' : null,
    couponHelpId: 'pop_BA_Import_Google_GetStarted',
    buttons: [
      { label: i18n.getString(Strings.ButtonGetStarted), onClick: onGotoGoogleImport, isPrimary: true },
      { label: dismissCount === 0 ? i18n.getString(Strings.ButtonNoDismiss) : i18n.getString(Strings.ButtonOneDismiss), onClick: onDismiss },
    ],
  }),

  [RecommendationID.PinterestNeverUsedId]: ({
    dismissCount, i18n, onGotoPinterestImport, onDismiss,
  }) => ({
    title: dismissCount === 0 ? i18n.getString(Strings.HeaderPinterestNeverUsedNoDismiss) : i18n.getString(Strings.HeaderPinterestNeverUsedOneDismiss),
    content: dismissCount === 0 ? i18n.getString(Strings.ContentPinterestNeverUsedNoDismiss) : i18n.getString(Strings.ContentPinterestNeverUsedOneDismiss),
    contentHelpId: dismissCount > 0 ? 'app54816' : null,
    couponHelpId: 'pop_BA_Import_PI_GetStarted',
    buttons: [
      { label: i18n.getString(Strings.ButtonGetStarted), onClick: onGotoPinterestImport, isPrimary: true },
      { label: dismissCount === 0 ? i18n.getString(Strings.ButtonNoDismiss) : i18n.getString(Strings.ButtonOneDismiss), onClick: onDismiss },
    ],
  }),

  [RecommendationID.FacebookAudienceSupportId]: ({
    dismissCount, i18n, onGotoFacebookImport, onDismiss,
  }) => ({
    title: dismissCount === 0 ? i18n.getString(Strings.HeaderFacebookAudienceSupportNoDismiss) : i18n.getString(Strings.HeaderFacebookAudienceSupportOneDismiss),
    content: dismissCount === 0 ? i18n.getString(Strings.ContentFacebookAudienceSupportNoDismiss) : i18n.getString(Strings.ContentFacebookAudienceSupportOneDismiss),
    contentHelpId: dismissCount > 0 ? 'app54769' : null,
    couponHelpId: 'pop_BA_Import_FB_GetStarted',
    buttons: [
      { label: i18n.getString(Strings.ButtonGetStarted), onClick: onGotoFacebookImport, isPrimary: true },
      { label: dismissCount === 0 ? i18n.getString(Strings.ButtonNoDismiss) : i18n.getString(Strings.ButtonOneDismiss), onClick: onDismiss },
    ],
  }),
};

export const getRecommendationViewModel = ({ recommendation, callbacks, i18n }) => {
  if (recommendation === null) return null;
  const { id, dismissCount } = recommendation;

  const getViewModel = recommendationVewModels[id];
  if (getViewModel) {
    return getViewModel({ dismissCount, i18n, ...callbacks });
  }
  return null;
};

